export function cdbIsNullOrUndefined(obj: object): boolean {
  return obj === null || obj === undefined;
}
